import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M8.447 5.315V4.25h7.106v1.065h-.927v6.786l.256.213c.362.266.724.607 1.044.969h-2.929l-.991 6.466-1.023-6.466H8.075c.32-.362.682-.703 1.044-.969l.256-.213V5.315h-.927z"
}), 'Pin');